export default defineNuxtLink({
    componentName: "MobileMenuLink",
    activeClass: "font-bold",
    exactActiveClass: "font-bold",
});